import BaseListPresenter from "../../../base/BaseListPresenter";
import { isAddendumBackPayItem, isBackPayItem } from "../Payroll/helper-payroll/constants/payrollConstants";

class EmployeeEarningsPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    this.limit = 10;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = []; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  async onEarningsChange(data, type) {
    const payrollType = type === "basic" ? "Basic Pay" : "Augmentation Pay";

    const [payrollPrinted] = await Promise.all([
      this.findObjectUseCase.execute("payroll_list", {
        where: {
          stats: "Printed",
          payrollType: payrollType,
        },
      }),
    ]);

    let backPayIds = [];
    let payrollIds = [];

    for (let i = 0; i < payrollPrinted.length; i++) {
      const payroll = payrollPrinted[i];
      const payItem = payroll?.payItem;
      const id = payroll?.id;

      if (isAddendumBackPayItem(payItem) || isBackPayItem(payItem)) {
        backPayIds.push(id);
      } else {
        payrollIds.push(id);
      }
    }

    this.view.setState((prevState) => ({
      panelState: {
        ...prevState.panelState,
        isBasicModal: true,
        employeeInfo: data,
        payrollType: type,
        payrollPrinted,
        payrollIds,
        backPayIds,
      },
    }));
  }
  onCloseFloating() {
    this.view.setState((prevState) => ({
      panelState: {
        ...prevState.panelState,
        isBasicModal: false,
      },
    }));
  }
}
export default EmployeeEarningsPresenter;
